import qs from 'qs-stringify'
import axios from 'axios'
const env = require('../env')
const packageJson = require('../package.json')
const { getSignature } = require('../utils/sign')
const { httpErrorStatusHandle } = require('../utils/statusTip')

const _config = {
    baseURL: env[packageJson.env].ENV_API,
    timeout: 30 * 1000,
    withCredentials: true
}
const service = axios.create(_config)

const requesthandler = async config => {
    if (config.data) {
        service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
        service.defaults.headers.post['x-oss-forbid-overwrite'] = true
    }
    let param = {}
    if (config.method == 'get') {
        param = await getSignature(config.params)
    } else {
        param = await getSignature(config.data, 'post')
    }

    config.headers.token = JSON.parse(localStorage.getItem('vuex')).user.token || null
    config.headers.PZPlatform = 'pc'
    if (process.client) {
        const setuserinfo = JSON.parse(localStorage.getItem('setuserinfo'))
        if (setuserinfo) {
            config.headers.PZid = JSON.parse(localStorage.getItem('setuserinfo')).id
        }
    }
    config.headers.PZOs = JSON.parse(localStorage.getItem('vuex')).operatingSystem
    config.headers.PZVersion = packageJson.version
    config.headers.PZVersionCode = '1'
    config.headers.Sign = param.strMd5
    config.headers.PZTimestamp = param.Timestamp
    config.headers.Random = param.Random
    if (config.method === 'post') {
        switch (config.url) {
        case '/login':
        case '/code-login':
        case '/third-login':
            config.data = qs(config.data)
            break
        default:
        }
    } else {
        config.params = { ...config.params }
    }

    return config
}
// 请求拦截
service.interceptors.request.use(
    async config => {
    //     if (config.data) {
    //         service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
    //         service.defaults.headers.post['x-oss-forbid-overwrite'] = true
    //     }
    //     let param = {}
    // if (config.method == 'get') {
    //     param = await getSignature(config.params)
    // } else {
    //     param = await getSignature(config.data, 'post')
    // }

        // config.headers.token = JSON.parse(localStorage.getItem('vuex')).user.token || null
        // config.headers['PZPlatform'] = 'pc'
        // if (process.client) {
        //     let setuserinfo = JSON.parse(localStorage.getItem('setuserinfo'))
        //     if (setuserinfo) {
        //         config.headers['PZid'] = JSON.parse(localStorage.getItem('setuserinfo')).id
        //     }
        // }
        // config.headers['PZOs'] = JSON.parse(localStorage.getItem('vuex')).operatingSystem
        // config.headers['PZVersion'] = packageJson.version
        // config.headers['PZVersionCode'] = '1'
        // config.headers['Sign'] = param.strMd5
        // config.headers['PZTimestamp'] = param.Timestamp
        // config.headers['Random'] = param.Random
        // if (config.method === 'post') {
        //     switch (config.url) {
        //         case '/login':
        //         case '/code-login':
        //         case '/third-login':
        //             config.data = qs(config.data)
        //             break
        //         default:
        //     }
        // } else {
        //     config.params = { ...config.params }
        // }
        return await requesthandler(config)
    },
    error => {
        // 对请求错误做些什么
        return Promise.reject(error)
    }
)
// 响应拦截
service.interceptors.response.use(
    response => {
        return response.data
    },
    err => {
        httpErrorStatusHandle(err)
        return Promise.reject(err)
    }
)

// 请求封装
const request = val => {
    const { data, url, method } = val
    if (method === 'get' || method === 'GET' || url.includes('/web-client/v2/payment/arousal/query/pay/success')) {
        return service({ url, method, params: data })
    } else {
        return service({ url, method, data })
    }
}

export const fetchAlive = async (url, data) => {
    const config = await requesthandler({
        method: 'post',
        data,
        headers: {}
    })
    fetch(`${url.includes('http') ? '' : _config.baseURL}${url}`, { method: 'POST', headers: { ...config.headers, 'Content-Type': 'application/json' }, body: JSON.stringify(data), credentials: 'include', keepalive: true })
}
export default request
